var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
/*!
 * jQuery UI Sortable 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Sortable
//>>group: Interactions
//>>description: Enables items in a list to be sorted using the mouse.
//>>docs: https://api.jqueryui.com/sortable/
//>>demos: https://jqueryui.com/sortable/
//>>css.structure: ../../themes/base/sortable.css

(function (factory) {
  "use strict";

  // Browser globals
  factory(jQuery);
})(function ($) {
  "use strict";

  return $.widget("ui.sortable", $.ui.mouse, {
    version: "1.13.3",
    widgetEventPrefix: "sort",
    ready: false,
    options: {
      appendTo: "parent",
      axis: false,
      connectWith: false,
      containment: false,
      cursor: "auto",
      cursorAt: false,
      dropOnEmpty: true,
      forcePlaceholderSize: false,
      forceHelperSize: false,
      grid: false,
      handle: false,
      helper: "original",
      items: "> *",
      opacity: false,
      placeholder: false,
      revert: false,
      scroll: true,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      scope: "default",
      tolerance: "intersect",
      zIndex: 1000,
      // Callbacks
      activate: null,
      beforeStop: null,
      change: null,
      deactivate: null,
      out: null,
      over: null,
      receive: null,
      remove: null,
      sort: null,
      start: null,
      stop: null,
      update: null
    },
    _isOverAxis: function (x, reference, size) {
      return x >= reference && x < reference + size;
    },
    _isFloating: function (item) {
      return /left|right/.test(item.css("float")) || /inline|table-cell/.test(item.css("display"));
    },
    _create: function () {
      (this || _global).containerCache = {};
      this._addClass("ui-sortable");

      //Get the items
      this.refresh();

      //Let's determine the parent's offset
      (this || _global).offset = (this || _global).element.offset();

      //Initialize mouse events for interaction
      this._mouseInit();
      this._setHandleClassName();

      //We're ready to go
      (this || _global).ready = true;
    },
    _setOption: function (key, value) {
      this._super(key, value);
      if (key === "handle") {
        this._setHandleClassName();
      }
    },
    _setHandleClassName: function () {
      var that = this || _global;
      this._removeClass((this || _global).element.find(".ui-sortable-handle"), "ui-sortable-handle");
      $.each((this || _global).items, function () {
        that._addClass((this || _global).instance.options.handle ? (this || _global).item.find((this || _global).instance.options.handle) : (this || _global).item, "ui-sortable-handle");
      });
    },
    _destroy: function () {
      this._mouseDestroy();
      for (var i = (this || _global).items.length - 1; i >= 0; i--) {
        (this || _global).items[i].item.removeData((this || _global).widgetName + "-item");
      }
      return this || _global;
    },
    _mouseCapture: function (event, overrideHandle) {
      var currentItem = null,
        validHandle = false,
        that = this || _global;
      if ((this || _global).reverting) {
        return false;
      }
      if ((this || _global).options.disabled || (this || _global).options.type === "static") {
        return false;
      }

      //We have to refresh the items data once first
      this._refreshItems(event);

      //Find out if the clicked node (or one of its parents) is a actual item in this.items
      $(event.target).parents().each(function () {
        if ($.data(this || _global, that.widgetName + "-item") === that) {
          currentItem = $(this || _global);
          return false;
        }
      });
      if ($.data(event.target, that.widgetName + "-item") === that) {
        currentItem = $(event.target);
      }
      if (!currentItem) {
        return false;
      }
      if ((this || _global).options.handle && !overrideHandle) {
        $((this || _global).options.handle, currentItem).find("*").addBack().each(function () {
          if ((this || _global) === event.target) {
            validHandle = true;
          }
        });
        if (!validHandle) {
          return false;
        }
      }
      (this || _global).currentItem = currentItem;
      this._removeCurrentsFromItems();
      return true;
    },
    _mouseStart: function (event, overrideHandle, noActivation) {
      var i,
        body,
        o = (this || _global).options;
      (this || _global).currentContainer = this || _global;

      //We only need to call refreshPositions, because the refreshItems call has been moved to
      // mouseCapture
      this.refreshPositions();

      //Prepare the dragged items parent
      (this || _global).appendTo = $(o.appendTo !== "parent" ? o.appendTo : (this || _global).currentItem.parent());

      //Create and append the visible helper
      (this || _global).helper = this._createHelper(event);

      //Cache the helper size
      this._cacheHelperProportions();

      /*
       * - Position generation -
       * This block generates everything position related - it's the core of draggables.
       */

      //Cache the margins of the original element
      this._cacheMargins();

      //The element's absolute position on the page minus margins
      (this || _global).offset = (this || _global).currentItem.offset();
      (this || _global).offset = {
        top: (this || _global).offset.top - (this || _global).margins.top,
        left: (this || _global).offset.left - (this || _global).margins.left
      };
      $.extend((this || _global).offset, {
        click: {
          //Where the click happened, relative to the element
          left: event.pageX - (this || _global).offset.left,
          top: event.pageY - (this || _global).offset.top
        },
        // This is a relative to absolute position minus the actual position calculation -
        // only used for relative positioned helper
        relative: this._getRelativeOffset()
      });

      // After we get the helper offset, but before we get the parent offset we can
      // change the helper's position to absolute
      // TODO: Still need to figure out a way to make relative sorting possible
      (this || _global).helper.css("position", "absolute");
      (this || _global).cssPosition = (this || _global).helper.css("position");

      //Adjust the mouse offset relative to the helper if "cursorAt" is supplied
      if (o.cursorAt) {
        this._adjustOffsetFromHelper(o.cursorAt);
      }

      //Cache the former DOM position
      (this || _global).domPosition = {
        prev: (this || _global).currentItem.prev()[0],
        parent: (this || _global).currentItem.parent()[0]
      };

      // If the helper is not the original, hide the original so it's not playing any role during
      // the drag, won't cause anything bad this way
      if ((this || _global).helper[0] !== (this || _global).currentItem[0]) {
        (this || _global).currentItem.hide();
      }

      //Create the placeholder
      this._createPlaceholder();

      //Get the next scrolling parent
      (this || _global).scrollParent = (this || _global).placeholder.scrollParent();
      $.extend((this || _global).offset, {
        parent: this._getParentOffset()
      });

      //Set a containment if given in the options
      if (o.containment) {
        this._setContainment();
      }
      if (o.cursor && o.cursor !== "auto") {
        // cursor option
        body = (this || _global).document.find("body");

        // Support: IE
        (this || _global).storedCursor = body.css("cursor");
        body.css("cursor", o.cursor);
        (this || _global).storedStylesheet = $("<style>*{ cursor: " + o.cursor + " !important; }</style>").appendTo(body);
      }

      // We need to make sure to grab the zIndex before setting the
      // opacity, because setting the opacity to anything lower than 1
      // causes the zIndex to change from "auto" to 0.
      if (o.zIndex) {
        // zIndex option
        if ((this || _global).helper.css("zIndex")) {
          (this || _global)._storedZIndex = (this || _global).helper.css("zIndex");
        }
        (this || _global).helper.css("zIndex", o.zIndex);
      }
      if (o.opacity) {
        // opacity option
        if ((this || _global).helper.css("opacity")) {
          (this || _global)._storedOpacity = (this || _global).helper.css("opacity");
        }
        (this || _global).helper.css("opacity", o.opacity);
      }

      //Prepare scrolling
      if ((this || _global).scrollParent[0] !== (this || _global).document[0] && (this || _global).scrollParent[0].tagName !== "HTML") {
        (this || _global).overflowOffset = (this || _global).scrollParent.offset();
      }

      //Call callbacks
      this._trigger("start", event, this._uiHash());

      //Recache the helper size
      if (!(this || _global)._preserveHelperProportions) {
        this._cacheHelperProportions();
      }

      //Post "activate" events to possible containers
      if (!noActivation) {
        for (i = (this || _global).containers.length - 1; i >= 0; i--) {
          (this || _global).containers[i]._trigger("activate", event, this._uiHash(this || _global));
        }
      }

      //Prepare possible droppables
      if ($.ui.ddmanager) {
        $.ui.ddmanager.current = this || _global;
      }
      if ($.ui.ddmanager && !o.dropBehaviour) {
        $.ui.ddmanager.prepareOffsets(this || _global, event);
      }
      (this || _global).dragging = true;
      this._addClass((this || _global).helper, "ui-sortable-helper");

      //Move the helper, if needed
      if (!(this || _global).helper.parent().is((this || _global).appendTo)) {
        (this || _global).helper.detach().appendTo((this || _global).appendTo);

        //Update position
        (this || _global).offset.parent = this._getParentOffset();
      }

      //Generate the original position
      (this || _global).position = (this || _global).originalPosition = this._generatePosition(event);
      (this || _global).originalPageX = event.pageX;
      (this || _global).originalPageY = event.pageY;
      (this || _global).lastPositionAbs = (this || _global).positionAbs = this._convertPositionTo("absolute");
      this._mouseDrag(event);
      return true;
    },
    _scroll: function (event) {
      var o = (this || _global).options,
        scrolled = false;
      if ((this || _global).scrollParent[0] !== (this || _global).document[0] && (this || _global).scrollParent[0].tagName !== "HTML") {
        if ((this || _global).overflowOffset.top + (this || _global).scrollParent[0].offsetHeight - event.pageY < o.scrollSensitivity) {
          (this || _global).scrollParent[0].scrollTop = scrolled = (this || _global).scrollParent[0].scrollTop + o.scrollSpeed;
        } else if (event.pageY - (this || _global).overflowOffset.top < o.scrollSensitivity) {
          (this || _global).scrollParent[0].scrollTop = scrolled = (this || _global).scrollParent[0].scrollTop - o.scrollSpeed;
        }
        if ((this || _global).overflowOffset.left + (this || _global).scrollParent[0].offsetWidth - event.pageX < o.scrollSensitivity) {
          (this || _global).scrollParent[0].scrollLeft = scrolled = (this || _global).scrollParent[0].scrollLeft + o.scrollSpeed;
        } else if (event.pageX - (this || _global).overflowOffset.left < o.scrollSensitivity) {
          (this || _global).scrollParent[0].scrollLeft = scrolled = (this || _global).scrollParent[0].scrollLeft - o.scrollSpeed;
        }
      } else {
        if (event.pageY - (this || _global).document.scrollTop() < o.scrollSensitivity) {
          scrolled = (this || _global).document.scrollTop((this || _global).document.scrollTop() - o.scrollSpeed);
        } else if ((this || _global).window.height() - (event.pageY - (this || _global).document.scrollTop()) < o.scrollSensitivity) {
          scrolled = (this || _global).document.scrollTop((this || _global).document.scrollTop() + o.scrollSpeed);
        }
        if (event.pageX - (this || _global).document.scrollLeft() < o.scrollSensitivity) {
          scrolled = (this || _global).document.scrollLeft((this || _global).document.scrollLeft() - o.scrollSpeed);
        } else if ((this || _global).window.width() - (event.pageX - (this || _global).document.scrollLeft()) < o.scrollSensitivity) {
          scrolled = (this || _global).document.scrollLeft((this || _global).document.scrollLeft() + o.scrollSpeed);
        }
      }
      return scrolled;
    },
    _mouseDrag: function (event) {
      var i,
        item,
        itemElement,
        intersection,
        o = (this || _global).options;

      //Compute the helpers position
      (this || _global).position = this._generatePosition(event);
      (this || _global).positionAbs = this._convertPositionTo("absolute");

      //Set the helper position
      if (!(this || _global).options.axis || (this || _global).options.axis !== "y") {
        (this || _global).helper[0].style.left = (this || _global).position.left + "px";
      }
      if (!(this || _global).options.axis || (this || _global).options.axis !== "x") {
        (this || _global).helper[0].style.top = (this || _global).position.top + "px";
      }

      //Do scrolling
      if (o.scroll) {
        if (this._scroll(event) !== false) {
          //Update item positions used in position checks
          this._refreshItemPositions(true);
          if ($.ui.ddmanager && !o.dropBehaviour) {
            $.ui.ddmanager.prepareOffsets(this || _global, event);
          }
        }
      }
      (this || _global).dragDirection = {
        vertical: this._getDragVerticalDirection(),
        horizontal: this._getDragHorizontalDirection()
      };

      //Rearrange
      for (i = (this || _global).items.length - 1; i >= 0; i--) {
        //Cache variables and intersection, continue if no intersection
        item = (this || _global).items[i];
        itemElement = item.item[0];
        intersection = this._intersectsWithPointer(item);
        if (!intersection) {
          continue;
        }

        // Only put the placeholder inside the current Container, skip all
        // items from other containers. This works because when moving
        // an item from one container to another the
        // currentContainer is switched before the placeholder is moved.
        //
        // Without this, moving items in "sub-sortables" can cause
        // the placeholder to jitter between the outer and inner container.
        if (item.instance !== (this || _global).currentContainer) {
          continue;
        }

        // Cannot intersect with itself
        // no useless actions that have been done before
        // no action if the item moved is the parent of the item checked
        if (itemElement !== (this || _global).currentItem[0] && (this || _global).placeholder[intersection === 1 ? "next" : "prev"]()[0] !== itemElement && !$.contains((this || _global).placeholder[0], itemElement) && ((this || _global).options.type === "semi-dynamic" ? !$.contains((this || _global).element[0], itemElement) : true)) {
          (this || _global).direction = intersection === 1 ? "down" : "up";
          if ((this || _global).options.tolerance === "pointer" || this._intersectsWithSides(item)) {
            this._rearrange(event, item);
          } else {
            break;
          }
          this._trigger("change", event, this._uiHash());
          break;
        }
      }

      //Post events to containers
      this._contactContainers(event);

      //Interconnect with droppables
      if ($.ui.ddmanager) {
        $.ui.ddmanager.drag(this || _global, event);
      }

      //Call callbacks
      this._trigger("sort", event, this._uiHash());
      (this || _global).lastPositionAbs = (this || _global).positionAbs;
      return false;
    },
    _mouseStop: function (event, noPropagation) {
      if (!event) {
        return;
      }

      //If we are using droppables, inform the manager about the drop
      if ($.ui.ddmanager && !(this || _global).options.dropBehaviour) {
        $.ui.ddmanager.drop(this || _global, event);
      }
      if ((this || _global).options.revert) {
        var that = this || _global,
          cur = (this || _global).placeholder.offset(),
          axis = (this || _global).options.axis,
          animation = {};
        if (!axis || axis === "x") {
          animation.left = cur.left - (this || _global).offset.parent.left - (this || _global).margins.left + ((this || _global).offsetParent[0] === (this || _global).document[0].body ? 0 : (this || _global).offsetParent[0].scrollLeft);
        }
        if (!axis || axis === "y") {
          animation.top = cur.top - (this || _global).offset.parent.top - (this || _global).margins.top + ((this || _global).offsetParent[0] === (this || _global).document[0].body ? 0 : (this || _global).offsetParent[0].scrollTop);
        }
        (this || _global).reverting = true;
        $((this || _global).helper).animate(animation, parseInt((this || _global).options.revert, 10) || 500, function () {
          that._clear(event);
        });
      } else {
        this._clear(event, noPropagation);
      }
      return false;
    },
    cancel: function () {
      if ((this || _global).dragging) {
        this._mouseUp(new $.Event("mouseup", {
          target: null
        }));
        if ((this || _global).options.helper === "original") {
          (this || _global).currentItem.css((this || _global)._storedCSS);
          this._removeClass((this || _global).currentItem, "ui-sortable-helper");
        } else {
          (this || _global).currentItem.show();
        }

        //Post deactivating events to containers
        for (var i = (this || _global).containers.length - 1; i >= 0; i--) {
          (this || _global).containers[i]._trigger("deactivate", null, this._uiHash(this || _global));
          if ((this || _global).containers[i].containerCache.over) {
            (this || _global).containers[i]._trigger("out", null, this._uiHash(this || _global));
            (this || _global).containers[i].containerCache.over = 0;
          }
        }
      }
      if ((this || _global).placeholder) {
        //$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
        // it unbinds ALL events from the original node!
        if ((this || _global).placeholder[0].parentNode) {
          (this || _global).placeholder[0].parentNode.removeChild((this || _global).placeholder[0]);
        }
        if ((this || _global).options.helper !== "original" && (this || _global).helper && (this || _global).helper[0].parentNode) {
          (this || _global).helper.remove();
        }
        $.extend(this || _global, {
          helper: null,
          dragging: false,
          reverting: false,
          _noFinalSort: null
        });
        if ((this || _global).domPosition.prev) {
          $((this || _global).domPosition.prev).after((this || _global).currentItem);
        } else {
          $((this || _global).domPosition.parent).prepend((this || _global).currentItem);
        }
      }
      return this || _global;
    },
    serialize: function (o) {
      var items = this._getItemsAsjQuery(o && o.connected),
        str = [];
      o = o || {};
      $(items).each(function () {
        var res = ($(o.item || this || _global).attr(o.attribute || "id") || "").match(o.expression || /(.+)[\-=_](.+)/);
        if (res) {
          str.push((o.key || res[1] + "[]") + "=" + (o.key && o.expression ? res[1] : res[2]));
        }
      });
      if (!str.length && o.key) {
        str.push(o.key + "=");
      }
      return str.join("&");
    },
    toArray: function (o) {
      var items = this._getItemsAsjQuery(o && o.connected),
        ret = [];
      o = o || {};
      items.each(function () {
        ret.push($(o.item || this || _global).attr(o.attribute || "id") || "");
      });
      return ret;
    },
    /* Be careful with the following core functions */
    _intersectsWith: function (item) {
      var x1 = (this || _global).positionAbs.left,
        x2 = x1 + (this || _global).helperProportions.width,
        y1 = (this || _global).positionAbs.top,
        y2 = y1 + (this || _global).helperProportions.height,
        l = item.left,
        r = l + item.width,
        t = item.top,
        b = t + item.height,
        dyClick = (this || _global).offset.click.top,
        dxClick = (this || _global).offset.click.left,
        isOverElementHeight = (this || _global).options.axis === "x" || y1 + dyClick > t && y1 + dyClick < b,
        isOverElementWidth = (this || _global).options.axis === "y" || x1 + dxClick > l && x1 + dxClick < r,
        isOverElement = isOverElementHeight && isOverElementWidth;
      if ((this || _global).options.tolerance === "pointer" || (this || _global).options.forcePointerForContainers || (this || _global).options.tolerance !== "pointer" && (this || _global).helperProportions[(this || _global).floating ? "width" : "height"] > item[(this || _global).floating ? "width" : "height"]) {
        return isOverElement;
      } else {
        return l < x1 + (this || _global).helperProportions.width / 2 &&
        // Right Half
        x2 - (this || _global).helperProportions.width / 2 < r &&
        // Left Half
        t < y1 + (this || _global).helperProportions.height / 2 &&
        // Bottom Half
        y2 - (this || _global).helperProportions.height / 2 < b; // Top Half
      }
    },

    _intersectsWithPointer: function (item) {
      var verticalDirection,
        horizontalDirection,
        isOverElementHeight = (this || _global).options.axis === "x" || this._isOverAxis((this || _global).positionAbs.top + (this || _global).offset.click.top, item.top, item.height),
        isOverElementWidth = (this || _global).options.axis === "y" || this._isOverAxis((this || _global).positionAbs.left + (this || _global).offset.click.left, item.left, item.width),
        isOverElement = isOverElementHeight && isOverElementWidth;
      if (!isOverElement) {
        return false;
      }
      verticalDirection = (this || _global).dragDirection.vertical;
      horizontalDirection = (this || _global).dragDirection.horizontal;
      return (this || _global).floating ? horizontalDirection === "right" || verticalDirection === "down" ? 2 : 1 : verticalDirection && (verticalDirection === "down" ? 2 : 1);
    },
    _intersectsWithSides: function (item) {
      var isOverBottomHalf = this._isOverAxis((this || _global).positionAbs.top + (this || _global).offset.click.top, item.top + item.height / 2, item.height),
        isOverRightHalf = this._isOverAxis((this || _global).positionAbs.left + (this || _global).offset.click.left, item.left + item.width / 2, item.width),
        verticalDirection = (this || _global).dragDirection.vertical,
        horizontalDirection = (this || _global).dragDirection.horizontal;
      if ((this || _global).floating && horizontalDirection) {
        return horizontalDirection === "right" && isOverRightHalf || horizontalDirection === "left" && !isOverRightHalf;
      } else {
        return verticalDirection && (verticalDirection === "down" && isOverBottomHalf || verticalDirection === "up" && !isOverBottomHalf);
      }
    },
    _getDragVerticalDirection: function () {
      var delta = (this || _global).positionAbs.top - (this || _global).lastPositionAbs.top;
      return delta !== 0 && (delta > 0 ? "down" : "up");
    },
    _getDragHorizontalDirection: function () {
      var delta = (this || _global).positionAbs.left - (this || _global).lastPositionAbs.left;
      return delta !== 0 && (delta > 0 ? "right" : "left");
    },
    refresh: function (event) {
      this._refreshItems(event);
      this._setHandleClassName();
      this.refreshPositions();
      return this || _global;
    },
    _connectWith: function () {
      var options = (this || _global).options;
      return options.connectWith.constructor === String ? [options.connectWith] : options.connectWith;
    },
    _getItemsAsjQuery: function (connected) {
      var i,
        j,
        cur,
        inst,
        items = [],
        queries = [],
        connectWith = this._connectWith();
      if (connectWith && connected) {
        for (i = connectWith.length - 1; i >= 0; i--) {
          cur = $(connectWith[i], (this || _global).document[0]);
          for (j = cur.length - 1; j >= 0; j--) {
            inst = $.data(cur[j], (this || _global).widgetFullName);
            if (inst && inst !== (this || _global) && !inst.options.disabled) {
              queries.push([typeof inst.options.items === "function" ? inst.options.items.call(inst.element) : $(inst.options.items, inst.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), inst]);
            }
          }
        }
      }
      queries.push([typeof (this || _global).options.items === "function" ? (this || _global).options.items.call((this || _global).element, null, {
        options: (this || _global).options,
        item: (this || _global).currentItem
      }) : $((this || _global).options.items, (this || _global).element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), this || _global]);
      function addItems() {
        items.push(this || _global);
      }
      for (i = queries.length - 1; i >= 0; i--) {
        queries[i][0].each(addItems);
      }
      return $(items);
    },
    _removeCurrentsFromItems: function () {
      var list = (this || _global).currentItem.find(":data(" + (this || _global).widgetName + "-item)");
      (this || _global).items = $.grep((this || _global).items, function (item) {
        for (var j = 0; j < list.length; j++) {
          if (list[j] === item.item[0]) {
            return false;
          }
        }
        return true;
      });
    },
    _refreshItems: function (event) {
      (this || _global).items = [];
      (this || _global).containers = [this || _global];
      var i,
        j,
        cur,
        inst,
        targetData,
        _queries,
        item,
        queriesLength,
        items = (this || _global).items,
        queries = [[typeof (this || _global).options.items === "function" ? (this || _global).options.items.call((this || _global).element[0], event, {
          item: (this || _global).currentItem
        }) : $((this || _global).options.items, (this || _global).element), this || _global]],
        connectWith = this._connectWith();

      //Shouldn't be run the first time through due to massive slow-down
      if (connectWith && (this || _global).ready) {
        for (i = connectWith.length - 1; i >= 0; i--) {
          cur = $(connectWith[i], (this || _global).document[0]);
          for (j = cur.length - 1; j >= 0; j--) {
            inst = $.data(cur[j], (this || _global).widgetFullName);
            if (inst && inst !== (this || _global) && !inst.options.disabled) {
              queries.push([typeof inst.options.items === "function" ? inst.options.items.call(inst.element[0], event, {
                item: (this || _global).currentItem
              }) : $(inst.options.items, inst.element), inst]);
              (this || _global).containers.push(inst);
            }
          }
        }
      }
      for (i = queries.length - 1; i >= 0; i--) {
        targetData = queries[i][1];
        _queries = queries[i][0];
        for (j = 0, queriesLength = _queries.length; j < queriesLength; j++) {
          item = $(_queries[j]);

          // Data for target checking (mouse manager)
          item.data((this || _global).widgetName + "-item", targetData);
          items.push({
            item: item,
            instance: targetData,
            width: 0,
            height: 0,
            left: 0,
            top: 0
          });
        }
      }
    },
    _refreshItemPositions: function (fast) {
      var i, item, t, p;
      for (i = (this || _global).items.length - 1; i >= 0; i--) {
        item = (this || _global).items[i];

        //We ignore calculating positions of all connected containers when we're not over them
        if ((this || _global).currentContainer && item.instance !== (this || _global).currentContainer && item.item[0] !== (this || _global).currentItem[0]) {
          continue;
        }
        t = (this || _global).options.toleranceElement ? $((this || _global).options.toleranceElement, item.item) : item.item;
        if (!fast) {
          item.width = t.outerWidth();
          item.height = t.outerHeight();
        }
        p = t.offset();
        item.left = p.left;
        item.top = p.top;
      }
    },
    refreshPositions: function (fast) {
      // Determine whether items are being displayed horizontally
      (this || _global).floating = (this || _global).items.length ? (this || _global).options.axis === "x" || this._isFloating((this || _global).items[0].item) : false;

      // This has to be redone because due to the item being moved out/into the offsetParent,
      // the offsetParent's position will change
      if ((this || _global).offsetParent && (this || _global).helper) {
        (this || _global).offset.parent = this._getParentOffset();
      }
      this._refreshItemPositions(fast);
      var i, p;
      if ((this || _global).options.custom && (this || _global).options.custom.refreshContainers) {
        (this || _global).options.custom.refreshContainers.call(this || _global);
      } else {
        for (i = (this || _global).containers.length - 1; i >= 0; i--) {
          p = (this || _global).containers[i].element.offset();
          (this || _global).containers[i].containerCache.left = p.left;
          (this || _global).containers[i].containerCache.top = p.top;
          (this || _global).containers[i].containerCache.width = (this || _global).containers[i].element.outerWidth();
          (this || _global).containers[i].containerCache.height = (this || _global).containers[i].element.outerHeight();
        }
      }
      return this || _global;
    },
    _createPlaceholder: function (that) {
      that = that || this || _global;
      var className,
        nodeName,
        o = that.options;
      if (!o.placeholder || o.placeholder.constructor === String) {
        className = o.placeholder;
        nodeName = that.currentItem[0].nodeName.toLowerCase();
        o.placeholder = {
          element: function () {
            var element = $("<" + nodeName + ">", that.document[0]);
            that._addClass(element, "ui-sortable-placeholder", className || that.currentItem[0].className)._removeClass(element, "ui-sortable-helper");
            if (nodeName === "tbody") {
              that._createTrPlaceholder(that.currentItem.find("tr").eq(0), $("<tr>", that.document[0]).appendTo(element));
            } else if (nodeName === "tr") {
              that._createTrPlaceholder(that.currentItem, element);
            } else if (nodeName === "img") {
              element.attr("src", that.currentItem.attr("src"));
            }
            if (!className) {
              element.css("visibility", "hidden");
            }
            return element;
          },
          update: function (container, p) {
            // 1. If a className is set as 'placeholder option, we don't force sizes -
            // the class is responsible for that
            // 2. The option 'forcePlaceholderSize can be enabled to force it even if a
            // class name is specified
            if (className && !o.forcePlaceholderSize) {
              return;
            }

            // If the element doesn't have a actual height or width by itself (without
            // styles coming from a stylesheet), it receives the inline height and width
            // from the dragged item. Or, if it's a tbody or tr, it's going to have a height
            // anyway since we're populating them with <td>s above, but they're unlikely to
            // be the correct height on their own if the row heights are dynamic, so we'll
            // always assign the height of the dragged item given forcePlaceholderSize
            // is true.
            if (!p.height() || o.forcePlaceholderSize && (nodeName === "tbody" || nodeName === "tr")) {
              p.height(that.currentItem.innerHeight() - parseInt(that.currentItem.css("paddingTop") || 0, 10) - parseInt(that.currentItem.css("paddingBottom") || 0, 10));
            }
            if (!p.width()) {
              p.width(that.currentItem.innerWidth() - parseInt(that.currentItem.css("paddingLeft") || 0, 10) - parseInt(that.currentItem.css("paddingRight") || 0, 10));
            }
          }
        };
      }

      //Create the placeholder
      that.placeholder = $(o.placeholder.element.call(that.element, that.currentItem));

      //Append it after the actual current item
      that.currentItem.after(that.placeholder);

      //Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
      o.placeholder.update(that, that.placeholder);
    },
    _createTrPlaceholder: function (sourceTr, targetTr) {
      var that = this || _global;
      sourceTr.children().each(function () {
        $("<td>&#160;</td>", that.document[0]).attr("colspan", $(this || _global).attr("colspan") || 1).appendTo(targetTr);
      });
    },
    _contactContainers: function (event) {
      var i,
        j,
        dist,
        itemWithLeastDistance,
        posProperty,
        sizeProperty,
        cur,
        nearBottom,
        floating,
        axis,
        innermostContainer = null,
        innermostIndex = null;

      // Get innermost container that intersects with item
      for (i = (this || _global).containers.length - 1; i >= 0; i--) {
        // Never consider a container that's located within the item itself
        if ($.contains((this || _global).currentItem[0], (this || _global).containers[i].element[0])) {
          continue;
        }
        if (this._intersectsWith((this || _global).containers[i].containerCache)) {
          // If we've already found a container and it's more "inner" than this, then continue
          if (innermostContainer && $.contains((this || _global).containers[i].element[0], innermostContainer.element[0])) {
            continue;
          }
          innermostContainer = (this || _global).containers[i];
          innermostIndex = i;
        } else {
          // container doesn't intersect. trigger "out" event if necessary
          if ((this || _global).containers[i].containerCache.over) {
            (this || _global).containers[i]._trigger("out", event, this._uiHash(this || _global));
            (this || _global).containers[i].containerCache.over = 0;
          }
        }
      }

      // If no intersecting containers found, return
      if (!innermostContainer) {
        return;
      }

      // Move the item into the container if it's not there already
      if ((this || _global).containers.length === 1) {
        if (!(this || _global).containers[innermostIndex].containerCache.over) {
          (this || _global).containers[innermostIndex]._trigger("over", event, this._uiHash(this || _global));
          (this || _global).containers[innermostIndex].containerCache.over = 1;
        }
      } else {
        // When entering a new container, we will find the item with the least distance and
        // append our item near it
        dist = 10000;
        itemWithLeastDistance = null;
        floating = innermostContainer.floating || this._isFloating((this || _global).currentItem);
        posProperty = floating ? "left" : "top";
        sizeProperty = floating ? "width" : "height";
        axis = floating ? "pageX" : "pageY";
        for (j = (this || _global).items.length - 1; j >= 0; j--) {
          if (!$.contains((this || _global).containers[innermostIndex].element[0], (this || _global).items[j].item[0])) {
            continue;
          }
          if ((this || _global).items[j].item[0] === (this || _global).currentItem[0]) {
            continue;
          }
          cur = (this || _global).items[j].item.offset()[posProperty];
          nearBottom = false;
          if (event[axis] - cur > (this || _global).items[j][sizeProperty] / 2) {
            nearBottom = true;
          }
          if (Math.abs(event[axis] - cur) < dist) {
            dist = Math.abs(event[axis] - cur);
            itemWithLeastDistance = (this || _global).items[j];
            (this || _global).direction = nearBottom ? "up" : "down";
          }
        }

        //Check if dropOnEmpty is enabled
        if (!itemWithLeastDistance && !(this || _global).options.dropOnEmpty) {
          return;
        }
        if ((this || _global).currentContainer === (this || _global).containers[innermostIndex]) {
          if (!(this || _global).currentContainer.containerCache.over) {
            (this || _global).containers[innermostIndex]._trigger("over", event, this._uiHash());
            (this || _global).currentContainer.containerCache.over = 1;
          }
          return;
        }
        if (itemWithLeastDistance) {
          this._rearrange(event, itemWithLeastDistance, null, true);
        } else {
          this._rearrange(event, null, (this || _global).containers[innermostIndex].element, true);
        }
        this._trigger("change", event, this._uiHash());
        (this || _global).containers[innermostIndex]._trigger("change", event, this._uiHash(this || _global));
        (this || _global).currentContainer = (this || _global).containers[innermostIndex];

        //Update the placeholder
        (this || _global).options.placeholder.update((this || _global).currentContainer, (this || _global).placeholder);

        //Update scrollParent
        (this || _global).scrollParent = (this || _global).placeholder.scrollParent();

        //Update overflowOffset
        if ((this || _global).scrollParent[0] !== (this || _global).document[0] && (this || _global).scrollParent[0].tagName !== "HTML") {
          (this || _global).overflowOffset = (this || _global).scrollParent.offset();
        }
        (this || _global).containers[innermostIndex]._trigger("over", event, this._uiHash(this || _global));
        (this || _global).containers[innermostIndex].containerCache.over = 1;
      }
    },
    _createHelper: function (event) {
      var o = (this || _global).options,
        helper = typeof o.helper === "function" ? $(o.helper.apply((this || _global).element[0], [event, (this || _global).currentItem])) : o.helper === "clone" ? (this || _global).currentItem.clone() : (this || _global).currentItem;

      //Add the helper to the DOM if that didn't happen already
      if (!helper.parents("body").length) {
        (this || _global).appendTo[0].appendChild(helper[0]);
      }
      if (helper[0] === (this || _global).currentItem[0]) {
        (this || _global)._storedCSS = {
          width: (this || _global).currentItem[0].style.width,
          height: (this || _global).currentItem[0].style.height,
          position: (this || _global).currentItem.css("position"),
          top: (this || _global).currentItem.css("top"),
          left: (this || _global).currentItem.css("left")
        };
      }
      if (!helper[0].style.width || o.forceHelperSize) {
        helper.width((this || _global).currentItem.width());
      }
      if (!helper[0].style.height || o.forceHelperSize) {
        helper.height((this || _global).currentItem.height());
      }
      return helper;
    },
    _adjustOffsetFromHelper: function (obj) {
      if (typeof obj === "string") {
        obj = obj.split(" ");
      }
      if (Array.isArray(obj)) {
        obj = {
          left: +obj[0],
          top: +obj[1] || 0
        };
      }
      if ("left" in obj) {
        (this || _global).offset.click.left = obj.left + (this || _global).margins.left;
      }
      if ("right" in obj) {
        (this || _global).offset.click.left = (this || _global).helperProportions.width - obj.right + (this || _global).margins.left;
      }
      if ("top" in obj) {
        (this || _global).offset.click.top = obj.top + (this || _global).margins.top;
      }
      if ("bottom" in obj) {
        (this || _global).offset.click.top = (this || _global).helperProportions.height - obj.bottom + (this || _global).margins.top;
      }
    },
    _getParentOffset: function () {
      //Get the offsetParent and cache its position
      (this || _global).offsetParent = (this || _global).helper.offsetParent();
      var po = (this || _global).offsetParent.offset();

      // This is a special case where we need to modify a offset calculated on start, since the
      // following happened:
      // 1. The position of the helper is absolute, so it's position is calculated based on the
      // next positioned parent
      // 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
      // the document, which means that the scroll is included in the initial calculation of the
      // offset of the parent, and never recalculated upon drag
      if ((this || _global).cssPosition === "absolute" && (this || _global).scrollParent[0] !== (this || _global).document[0] && $.contains((this || _global).scrollParent[0], (this || _global).offsetParent[0])) {
        po.left += (this || _global).scrollParent.scrollLeft();
        po.top += (this || _global).scrollParent.scrollTop();
      }

      // This needs to be actually done for all browsers, since pageX/pageY includes this
      // information with an ugly IE fix
      if ((this || _global).offsetParent[0] === (this || _global).document[0].body || (this || _global).offsetParent[0].tagName && (this || _global).offsetParent[0].tagName.toLowerCase() === "html" && $.ui.ie) {
        po = {
          top: 0,
          left: 0
        };
      }
      return {
        top: po.top + (parseInt((this || _global).offsetParent.css("borderTopWidth"), 10) || 0),
        left: po.left + (parseInt((this || _global).offsetParent.css("borderLeftWidth"), 10) || 0)
      };
    },
    _getRelativeOffset: function () {
      if ((this || _global).cssPosition === "relative") {
        var p = (this || _global).currentItem.position();
        return {
          top: p.top - (parseInt((this || _global).helper.css("top"), 10) || 0) + (this || _global).scrollParent.scrollTop(),
          left: p.left - (parseInt((this || _global).helper.css("left"), 10) || 0) + (this || _global).scrollParent.scrollLeft()
        };
      } else {
        return {
          top: 0,
          left: 0
        };
      }
    },
    _cacheMargins: function () {
      (this || _global).margins = {
        left: parseInt((this || _global).currentItem.css("marginLeft"), 10) || 0,
        top: parseInt((this || _global).currentItem.css("marginTop"), 10) || 0
      };
    },
    _cacheHelperProportions: function () {
      (this || _global).helperProportions = {
        width: (this || _global).helper.outerWidth(),
        height: (this || _global).helper.outerHeight()
      };
    },
    _setContainment: function () {
      var ce,
        co,
        over,
        o = (this || _global).options;
      if (o.containment === "parent") {
        o.containment = (this || _global).helper[0].parentNode;
      }
      if (o.containment === "document" || o.containment === "window") {
        (this || _global).containment = [0 - (this || _global).offset.relative.left - (this || _global).offset.parent.left, 0 - (this || _global).offset.relative.top - (this || _global).offset.parent.top, o.containment === "document" ? (this || _global).document.width() : (this || _global).window.width() - (this || _global).helperProportions.width - (this || _global).margins.left, (o.containment === "document" ? (this || _global).document.height() || document.body.parentNode.scrollHeight : (this || _global).window.height() || (this || _global).document[0].body.parentNode.scrollHeight) - (this || _global).helperProportions.height - (this || _global).margins.top];
      }
      if (!/^(document|window|parent)$/.test(o.containment)) {
        ce = $(o.containment)[0];
        co = $(o.containment).offset();
        over = $(ce).css("overflow") !== "hidden";
        (this || _global).containment = [co.left + (parseInt($(ce).css("borderLeftWidth"), 10) || 0) + (parseInt($(ce).css("paddingLeft"), 10) || 0) - (this || _global).margins.left, co.top + (parseInt($(ce).css("borderTopWidth"), 10) || 0) + (parseInt($(ce).css("paddingTop"), 10) || 0) - (this || _global).margins.top, co.left + (over ? Math.max(ce.scrollWidth, ce.offsetWidth) : ce.offsetWidth) - (parseInt($(ce).css("borderLeftWidth"), 10) || 0) - (parseInt($(ce).css("paddingRight"), 10) || 0) - (this || _global).helperProportions.width - (this || _global).margins.left, co.top + (over ? Math.max(ce.scrollHeight, ce.offsetHeight) : ce.offsetHeight) - (parseInt($(ce).css("borderTopWidth"), 10) || 0) - (parseInt($(ce).css("paddingBottom"), 10) || 0) - (this || _global).helperProportions.height - (this || _global).margins.top];
      }
    },
    _convertPositionTo: function (d, pos) {
      if (!pos) {
        pos = (this || _global).position;
      }
      var mod = d === "absolute" ? 1 : -1,
        scroll = (this || _global).cssPosition === "absolute" && !((this || _global).scrollParent[0] !== (this || _global).document[0] && $.contains((this || _global).scrollParent[0], (this || _global).offsetParent[0])) ? (this || _global).offsetParent : (this || _global).scrollParent,
        scrollIsRootNode = /(html|body)/i.test(scroll[0].tagName);
      return {
        top:
        // The absolute mouse position
        pos.top +
        // Only for relative positioned nodes: Relative offset from element to offset parent
        (this || _global).offset.relative.top * mod +
        // The offsetParent's offset without borders (offset + border)
        (this || _global).offset.parent.top * mod - ((this || _global).cssPosition === "fixed" ? -(this || _global).scrollParent.scrollTop() : scrollIsRootNode ? 0 : scroll.scrollTop()) * mod,
        left:
        // The absolute mouse position
        pos.left +
        // Only for relative positioned nodes: Relative offset from element to offset parent
        (this || _global).offset.relative.left * mod +
        // The offsetParent's offset without borders (offset + border)
        (this || _global).offset.parent.left * mod - ((this || _global).cssPosition === "fixed" ? -(this || _global).scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft()) * mod
      };
    },
    _generatePosition: function (event) {
      var top,
        left,
        o = (this || _global).options,
        pageX = event.pageX,
        pageY = event.pageY,
        scroll = (this || _global).cssPosition === "absolute" && !((this || _global).scrollParent[0] !== (this || _global).document[0] && $.contains((this || _global).scrollParent[0], (this || _global).offsetParent[0])) ? (this || _global).offsetParent : (this || _global).scrollParent,
        scrollIsRootNode = /(html|body)/i.test(scroll[0].tagName);

      // This is another very weird special case that only happens for relative elements:
      // 1. If the css position is relative
      // 2. and the scroll parent is the document or similar to the offset parent
      // we have to refresh the relative offset during the scroll so there are no jumps
      if ((this || _global).cssPosition === "relative" && !((this || _global).scrollParent[0] !== (this || _global).document[0] && (this || _global).scrollParent[0] !== (this || _global).offsetParent[0])) {
        (this || _global).offset.relative = this._getRelativeOffset();
      }

      /*
       * - Position constraining -
       * Constrain the position to a mix of grid, containment.
       */

      if ((this || _global).originalPosition) {
        //If we are not dragging yet, we won't check for options

        if ((this || _global).containment) {
          if (event.pageX - (this || _global).offset.click.left < (this || _global).containment[0]) {
            pageX = (this || _global).containment[0] + (this || _global).offset.click.left;
          }
          if (event.pageY - (this || _global).offset.click.top < (this || _global).containment[1]) {
            pageY = (this || _global).containment[1] + (this || _global).offset.click.top;
          }
          if (event.pageX - (this || _global).offset.click.left > (this || _global).containment[2]) {
            pageX = (this || _global).containment[2] + (this || _global).offset.click.left;
          }
          if (event.pageY - (this || _global).offset.click.top > (this || _global).containment[3]) {
            pageY = (this || _global).containment[3] + (this || _global).offset.click.top;
          }
        }
        if (o.grid) {
          top = (this || _global).originalPageY + Math.round((pageY - (this || _global).originalPageY) / o.grid[1]) * o.grid[1];
          pageY = (this || _global).containment ? top - (this || _global).offset.click.top >= (this || _global).containment[1] && top - (this || _global).offset.click.top <= (this || _global).containment[3] ? top : top - (this || _global).offset.click.top >= (this || _global).containment[1] ? top - o.grid[1] : top + o.grid[1] : top;
          left = (this || _global).originalPageX + Math.round((pageX - (this || _global).originalPageX) / o.grid[0]) * o.grid[0];
          pageX = (this || _global).containment ? left - (this || _global).offset.click.left >= (this || _global).containment[0] && left - (this || _global).offset.click.left <= (this || _global).containment[2] ? left : left - (this || _global).offset.click.left >= (this || _global).containment[0] ? left - o.grid[0] : left + o.grid[0] : left;
        }
      }
      return {
        top:
        // The absolute mouse position
        pageY -
        // Click offset (relative to the element)
        (this || _global).offset.click.top -
        // Only for relative positioned nodes: Relative offset from element to offset parent
        (this || _global).offset.relative.top -
        // The offsetParent's offset without borders (offset + border)
        (this || _global).offset.parent.top + ((this || _global).cssPosition === "fixed" ? -(this || _global).scrollParent.scrollTop() : scrollIsRootNode ? 0 : scroll.scrollTop()),
        left:
        // The absolute mouse position
        pageX -
        // Click offset (relative to the element)
        (this || _global).offset.click.left -
        // Only for relative positioned nodes: Relative offset from element to offset parent
        (this || _global).offset.relative.left -
        // The offsetParent's offset without borders (offset + border)
        (this || _global).offset.parent.left + ((this || _global).cssPosition === "fixed" ? -(this || _global).scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft())
      };
    },
    _rearrange: function (event, i, a, hardRefresh) {
      if (a) {
        a[0].appendChild((this || _global).placeholder[0]);
      } else {
        i.item[0].parentNode.insertBefore((this || _global).placeholder[0], (this || _global).direction === "down" ? i.item[0] : i.item[0].nextSibling);
      }

      //Various things done here to improve the performance:
      // 1. we create a setTimeout, that calls refreshPositions
      // 2. on the instance, we have a counter variable, that get's higher after every append
      // 3. on the local scope, we copy the counter variable, and check in the timeout,
      // if it's still the same
      // 4. this lets only the last addition to the timeout stack through
      (this || _global).counter = (this || _global).counter ? ++(this || _global).counter : 1;
      var counter = (this || _global).counter;
      this._delay(function () {
        if (counter === (this || _global).counter) {
          //Precompute after each DOM insertion, NOT on mousemove
          this.refreshPositions(!hardRefresh);
        }
      });
    },
    _clear: function (event, noPropagation) {
      (this || _global).reverting = false;

      // We delay all events that have to be triggered to after the point where the placeholder
      // has been removed and everything else normalized again
      var i,
        delayedTriggers = [];

      // We first have to update the dom position of the actual currentItem
      // Note: don't do it if the current item is already removed (by a user), or it gets
      // reappended (see #4088)
      if (!(this || _global)._noFinalSort && (this || _global).currentItem.parent().length) {
        (this || _global).placeholder.before((this || _global).currentItem);
      }
      (this || _global)._noFinalSort = null;
      if ((this || _global).helper[0] === (this || _global).currentItem[0]) {
        for (i in (this || _global)._storedCSS) {
          if ((this || _global)._storedCSS[i] === "auto" || (this || _global)._storedCSS[i] === "static") {
            (this || _global)._storedCSS[i] = "";
          }
        }
        (this || _global).currentItem.css((this || _global)._storedCSS);
        this._removeClass((this || _global).currentItem, "ui-sortable-helper");
      } else {
        (this || _global).currentItem.show();
      }
      if ((this || _global).fromOutside && !noPropagation) {
        delayedTriggers.push(function (event) {
          this._trigger("receive", event, this._uiHash((this || _global).fromOutside));
        });
      }
      if (((this || _global).fromOutside || (this || _global).domPosition.prev !== (this || _global).currentItem.prev().not(".ui-sortable-helper")[0] || (this || _global).domPosition.parent !== (this || _global).currentItem.parent()[0]) && !noPropagation) {
        // Trigger update callback if the DOM position has changed
        delayedTriggers.push(function (event) {
          this._trigger("update", event, this._uiHash());
        });
      }

      // Check if the items Container has Changed and trigger appropriate
      // events.
      if ((this || _global) !== (this || _global).currentContainer) {
        if (!noPropagation) {
          delayedTriggers.push(function (event) {
            this._trigger("remove", event, this._uiHash());
          });
          delayedTriggers.push(function (c) {
            return function (event) {
              c._trigger("receive", event, this._uiHash(this || _global));
            };
          }.call(this || _global, (this || _global).currentContainer));
          delayedTriggers.push(function (c) {
            return function (event) {
              c._trigger("update", event, this._uiHash(this || _global));
            };
          }.call(this || _global, (this || _global).currentContainer));
        }
      }

      //Post events to containers
      function delayEvent(type, instance, container) {
        return function (event) {
          container._trigger(type, event, instance._uiHash(instance));
        };
      }
      for (i = (this || _global).containers.length - 1; i >= 0; i--) {
        if (!noPropagation) {
          delayedTriggers.push(delayEvent("deactivate", this || _global, (this || _global).containers[i]));
        }
        if ((this || _global).containers[i].containerCache.over) {
          delayedTriggers.push(delayEvent("out", this || _global, (this || _global).containers[i]));
          (this || _global).containers[i].containerCache.over = 0;
        }
      }

      //Do what was originally in plugins
      if ((this || _global).storedCursor) {
        (this || _global).document.find("body").css("cursor", (this || _global).storedCursor);
        (this || _global).storedStylesheet.remove();
      }
      if ((this || _global)._storedOpacity) {
        (this || _global).helper.css("opacity", (this || _global)._storedOpacity);
      }
      if ((this || _global)._storedZIndex) {
        (this || _global).helper.css("zIndex", (this || _global)._storedZIndex === "auto" ? "" : (this || _global)._storedZIndex);
      }
      (this || _global).dragging = false;
      if (!noPropagation) {
        this._trigger("beforeStop", event, this._uiHash());
      }

      //$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
      // it unbinds ALL events from the original node!
      (this || _global).placeholder[0].parentNode.removeChild((this || _global).placeholder[0]);
      if (!(this || _global).cancelHelperRemoval) {
        if ((this || _global).helper[0] !== (this || _global).currentItem[0]) {
          (this || _global).helper.remove();
        }
        (this || _global).helper = null;
      }
      if (!noPropagation) {
        for (i = 0; i < delayedTriggers.length; i++) {
          // Trigger all delayed events
          delayedTriggers[i].call(this || _global, event);
        }
        this._trigger("stop", event, this._uiHash());
      }
      (this || _global).fromOutside = false;
      return !(this || _global).cancelHelperRemoval;
    },
    _trigger: function () {
      if ($.Widget.prototype._trigger.apply(this || _global, arguments) === false) {
        this.cancel();
      }
    },
    _uiHash: function (_inst) {
      var inst = _inst || this || _global;
      return {
        helper: inst.helper,
        placeholder: inst.placeholder || $([]),
        position: inst.position,
        originalPosition: inst.originalPosition,
        offset: inst.positionAbs,
        item: inst.currentItem,
        sender: _inst ? _inst.element : null
      };
    }
  });
});
export default {};